const toNumber = (value) => parseFloat(value) || 0;

export const isVisible = (customizationFields, key) => customizationFields[key] !== false;

export const getActiveSetting = (customizationFields, key) => {
    const setting = customizationFields[key];
    if (! setting) return null;
    if (! setting.is_active) return null;
    return setting;
}

export const getPageMargins = (customizationFields, defaultPageMargins) => {
    const setting = getActiveSetting(customizationFields, 'extra_settings_margin');
    if (! setting) return defaultPageMargins;
    if (! setting.value) return defaultPageMargins;
    const margin = setting.value;
    return [toNumber(margin.left), toNumber(margin.top), toNumber(margin.right), toNumber(margin.bottom)];
}

export const resolveFontSize = (customizationFields, defaultFontSize) => {
    const setting = getActiveSetting(customizationFields, 'extra_settings_font_size');
    if (! setting) return defaultFontSize;
    const size = parseFloat(setting.value);
    if (isNaN(size)) return defaultFontSize;
    if (size <= 0) return defaultFontSize;
    return size;
}
